module.exports = __webpack_public_path__ + "img/MASTERCARD_60x36.dee7d717.jpg";